<template>
    <div class="mech-page">
        <div class="live-area">
            <gameInfoTitle title="機甲外觀"></gameInfoTitle>
            <div class="liveImg">
                <img :src="detailData.liveSrc ? detailData.liveSrc : ''" alt="">
            </div>
        </div>
        <div class="switch-area">
            <switchInfo desc="切換至最高品質滿級數據" @switch="switchFullLevel" :status="isFullLevel"></switchInfo>
        </div>
        <div v-for="(item, index) in gridData" :key="index" :class="item.class" class="part-area">
            <gameInfoTitle :title="item.title" :isCenter="true" class="part-area-title"></gameInfoTitle>
            <baseInfoWrap :title="item.wrapTitle" :useBorder="false" titleColor="#d3d5da" textColor="#e9eaed">
                <table class="part-table">
                    <tr>
                        <td class="part-icon" rowspan="4">
                            <div class="icon-area">
                                <gameObjCard :type="3" :hasName="false"
                                    :quality="getCellData(item.dataSource, item.data[1].value, 'SR')"
                                    :src="getCellData(item.dataSource, 'partIcon', '')"></gameObjCard>
                            </div>
                        </td>
                        <td class="part-content">
                            <div class="text-area">
                                <p class="text-area-title">{{ item.data[0].attr }}</p>
                                <p class="text-area-content">{{ getCellData(item.dataSource, item.data[0].value) }}</p>
                            </div>
                        </td>
                        <td class="part-content">
                            <div class="text-area">
                                <p class="text-area-title">{{ item.data[1].attr }}</p>
                                <p class="text-area-content">{{ getCellData(item.dataSource, item.data[1].value, 'SR') | filterQulity
                                }}</p>
                            </div>

                        </td>
                        <td class="part-content">
                            <div class="text-area">
                                <p class="text-area-title">{{ item.data[2].attr }}</p>
                                <p class="text-area-content">{{ getCellData(item.dataSource, item.data[2].value) }}</p>
                            </div>

                        </td>
                    </tr>
                    <tr>
                        <td class="part-content">
                            <div class="text-area">
                                <p class="text-area-title">{{ item.data[3].attr }}</p>
                                <p class="text-area-content">{{ getCellData(item.dataSource, item.data[3].value) }}</p>
                            </div>

                        </td>
                        <td class="part-content">
                            <div class="text-area">
                                <p class="text-area-title">{{ item.data[4].attr }}</p>
                                <p class="text-area-content">{{ getCellData(item.dataSource, item.data[4].value) }}</p>
                            </div>

                        </td>
                        <td class="part-content">
                            <div class="text-area">
                                <p class="text-area-title">{{ item.data[5].attr }}</p>
                                <p class="text-area-content">{{ getCellData(item.dataSource, item.data[5].value) }}</p>
                            </div>

                        </td>
                    </tr>
                    <tr>
                        <td class="part-content">
                            <div class="text-area">
                                <p class="text-area-title">{{ item.data[6].attr }}</p>
                                <p class="text-area-content">{{ getCellData(item.dataSource, item.data[6].value) }}</p>
                            </div>

                        </td>
                        <td class="part-content">
                            <div class="text-area">
                                <p class="text-area-title">{{ item.data[7].attr }}</p>
                                <p class="text-area-content">{{ getCellData(item.dataSource, item.data[7].value) }}</p>
                            </div>

                        </td>
                        <td class="part-content">
                            <div class="text-area">
                                <p class="text-area-title">{{ item.data[8].attr }}</p>
                                <p class="text-area-content">{{ getCellData(item.dataSource, item.data[8].value) }}</p>
                            </div>
                        </td>
                    </tr>
                </table>
            </baseInfoWrap>
        </div>
        <div class="module-area" v-if="currentDetailData.moduleInfo && currentDetailData.moduleInfo.length > 0">
            <gameInfoTitle title="機甲模組" :isCenter="true"></gameInfoTitle>
            <baseInfoWrap title="JI BING MO ZU" :useBorder="false" titleColor="#d3d5da" textColor="#e9eaed">
                <table class="moudle-table">
                    <tr v-for="(item, index) in currentDetailData.moduleInfo" :key="index">
                        <td class="module-icon">
                            <div class="module-icon-wrap">
                                <img :src="item.moduleIcon" alt="">
                            </div>
                        </td>
                        <td class="module-content">
                            <div class="module-content-wrap">
                                <p class="module-title">{{ item.moduleName }}</p>
                                <p class="module-desc" v-html="item.moduleDesc"></p>
                            </div>
                        </td>
                    </tr>
                </table>
            </baseInfoWrap>

        </div>
        <div class="desc-area">
            <div class="desc-title">
                <p>相關背景</p>
            </div>
            <div class="desc-content" v-html="formatDesc(detailData.desc)"></div>
        </div>
    </div>
</template>

<script>
import switchInfo from '../components/base/switchInfo.vue';
import gameObjCard from '../components/base/gameObjCard.vue';
import gameInfoTitle from '../components/gameInfoTitle.vue';
import baseInfoWrap from '../components/base/baseInfoWrap.vue';
export default {
    components: { gameInfoTitle, baseInfoWrap, gameObjCard, switchInfo },
    props: {
        detailData: {
            type: Object,
            required: true
        }
    },
    filters: {
        filterQulity(value) {
            switch(value){
                case 'SSSR':
                    return 'S'
                case 'SSR':
                    return 'S'
                case 'SR':
                    return 'A'
                case 'R':
                    return 'B'
                case 'C':
                    return 'C'
            }
        }
    },
    methods: {
        getCellData(dataSource, dataKey, defaultValue) {
            if (!this.currentDetailData[dataSource]) {
                return defaultValue || ''
            }
            if (!this.currentDetailData[dataSource][dataKey]) {
                return defaultValue || ''
            }
            return this.currentDetailData[dataSource][dataKey]
        },
        switchFullLevel(status) {
            this.isFullLevel = status
        },
        formatDesc(desc) {
            if (!desc) {
                return ''
            }else{
                return desc.replace(/\n/g, '<br/>')
            }
        }
    },
    data() {
        return {
            gridData: [
                {
                    title: '軀幹資訊',
                    wrapTitle: 'QU GAN XIN XI',
                    class: 'body-area',
                    dataSource: 'bodyInfo',
                    data: [
                        { attr: '名稱:', value: 'partName' },
                        { attr: '品質:', value: 'partQuality' },
                        { attr: '火力:', value: 'partFire' },
                        { attr: '耐久:', value: 'partDurability' },
                        { attr: '護甲:', value: 'partArmor' },
                        { attr: '出力:', value: 'partPower' },
                        { attr: '重量:', value: 'partWeight' },
                        { attr: '抗暴:', value: 'partAnti' },
                        { attr: '接口:', value: 'partPort' },
                    ]
                },
                {
                    title: '右臂資訊',
                    wrapTitle: 'YOU BI XIN XI',
                    class: 'right-arm-area',
                    dataSource: 'rightArmInfo',
                    data: [
                        { attr: '名稱:', value: 'partName' },
                        { attr: '品質:', value: 'partQuality' },
                        { attr: '火力:', value: 'partFire' },
                        { attr: '耐久:', value: 'partDurability' },
                        { attr: '護甲:', value: 'partArmor' },
                        { attr: '命中:', value: 'partHit' },
                        { attr: '重量:', value: 'partWeight' },
                        { attr: '-', value: '-' },
                        { attr: '接口:', value: 'partPort' },
                    ]
                },
                {
                    title: '左臂資訊',
                    wrapTitle: 'ZUO BI XIN XI',
                    class: 'left-arm-area',
                    dataSource: 'leftArmInfo',
                    data: [
                        { attr: '名稱:', value: 'partName' },
                        { attr: '品質:', value: 'partQuality' },
                        { attr: '火力:', value: 'partFire' },
                        { attr: '耐久:', value: 'partDurability' },
                        { attr: '護甲:', value: 'partArmor' },
                        { attr: '命中:', value: 'partHit' },
                        { attr: '重量:', value: 'partWeight' },
                        { attr: '-', value: '' },
                        { attr: '接口:', value: 'partPort' },
                    ]
                },
                {
                    title: '腿部資訊',
                    wrapTitle: 'TUI BU XIN XI',
                    class: 'leg-area',
                    dataSource: 'legInfo',
                    data: [
                        { attr: '名稱:', value: 'partName' },
                        { attr: '品質:', value: 'partQuality' },
                        { attr: '火力:', value: 'partFire' },
                        { attr: '耐久:', value: 'partDurability' },
                        { attr: '護甲:', value: 'partArmor' },
                        { attr: '闪避:', value: 'partDodge' },
                        { attr: '重量:', value: 'partWeight' },
                        { attr: '移动:', value: 'partMove' },
                        { attr: '接口:', value: 'partPort' },
                    ]
                }
            ],
            isFullLevel: false
        }
    },
    computed: {
        currentDetailData() {
            if (!this.detailData) {
                return {}
            }
            if (this.isFullLevel) {
                return this.detailData.full || {}
            } else {
                return this.detailData.origin || {}
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.mech-page {
    .live-area {
        margin-bottom: .3rem;

        .liveImg {
            height: 7.4rem;
            margin-top: .3rem;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }

    .switch-area {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .part-area {
        margin-bottom: .3rem;

        &-title {
            margin-bottom: .1rem;
        }

        .part-table {
            border-collapse: collapse;
            border-spacing: 0;
            width: 100%;
            height: 1.7rem;

            td {
                border-color: #d3d5da;
                border-style: solid;
                border-width: 1px;
            }

            tr:nth-child(odd) {
                background-color: #f2f2f4;
            }

            .part-icon {
                width: 25%;
                background-color: white;

                .icon-area {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }

        .part-content {
            padding: .1rem;
            width: 25%;

            .text-area {
                display: flex;
                align-items: center;
                justify-content: center;

                p {
                    font-size: .22rem;
                }

                .text-area-title {
                    font-weight: bold;
                    margin-right: .3rem;
                }

                .text-area-content {
                    color: #404040;
                }
            }


        }
    }

    .module-area {
        margin-bottom: .3rem;
        .moudle-table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            width: 100%;

            td {
                border-color: #d3d5da;
                border-style: solid;
                border-width: 1px;
            }

            tr:nth-child(odd) {
                background-color: #f2f2f4;
            }

            .module-icon {
                height: 1.3rem;
                width: 1.3rem;

                &-wrap {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: .9rem;
                        height: .9rem;
                        object-fit: contain;
                    }
                }
            }

            .module-content {
                &-wrap {
                    padding: .1rem;
                    font-size: .22rem;

                    .module-title {}

                    .module-desc {}
                }

            }
        }
    }

    .desc-area {
        .desc-title {
            height: .48rem;
            font-size: .24rem;
            background-color: #d2d5da;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .desc-content {
            font-size: .2rem;
            color: #8a98a4;
            border: 2px solid #d2d5da;
            min-height: .85rem;
            padding: .18rem .2rem;
        }
    }
}
</style>
